import { useAgencyCampaignContext } from '../../agencyCampaignContext';
import { AgencyCampaignSection } from '../../../agency/model';
import { Link, useSearch } from '@tanstack/react-router';
import { cn } from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';
import { CreativesTable } from '../components/CreativesTable/CreativesTable';
import { creativesRouteSearchSchema, type CreativesRouteSearch } from '../creativesRouteSearch';
import { CreativeTab } from '../model';

const creativeTabs = [
  {
    tab: CreativeTab.Display,
    to: '/campaigns/creatives/display',
    label: 'creatives.tab.display',
  },
  {
    tab: CreativeTab.Video,
    to: '/campaigns/creatives/video',
    label: 'creatives.tab.video',
  },
] as const;

export function CreativesPage({ tab }: { tab: CreativeTab }) {
  const scope = useAgencyCampaignContext();
  const search = creativesRouteSearchSchema(useSearch({ strict: false }));
  const tabSearch: CreativesRouteSearch = search.brand ? { brand: search.brand } : {};

  return (
    <>
      <nav
        aria-label={dashboardT('nav.campaigns.creatives')}
        className="border-border bg-card page-gutter border-b"
      >
        <div className="flex min-w-max gap-1 overflow-x-auto">
          {creativeTabs.map((entry) => {
            const active = entry.tab === tab;
            return (
              <Link
                key={entry.tab}
                to={scope ? '/a/$agencyId/campaigns/$section' : entry.to}
                params={{
                  agencyId: scope?.agency.id ?? '',
                  section: AgencyCampaignSection.Creatives,
                }}
                search={{ ...tabSearch, ...(scope ? { creativeTab: entry.tab } : {}) }}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'text-muted-foreground border-b-2 border-transparent px-3 py-3 text-sm font-medium whitespace-nowrap transition-colors',
                  active && 'shigo-supply-tab--active',
                )}
              >
                {dashboardT(entry.label)}
              </Link>
            );
          })}
        </div>
      </nav>
      <CreativesTable tab={tab} />
    </>
  );
}
